import React, { useState, useEffect } from "react";
import i18n from "../i18n.js";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import Alert from "@mui/material/Alert";
import Container from "@mui/material/Container";
import axios from "axios";
import BlocksWithCategories from "./components/BlocksWithCategories";
import Starter from "./components/Starter";
import CircularProgress from "@mui/material/CircularProgress";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import KeyIcon from "@mui/icons-material/Key";
import Input from "@mui/material/Input";
import AlertTitle from '@mui/material/AlertTitle';
import Button from '@mui/material/Button';
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import RejectedCategoriesDialog from "./components/RejectedCategoriesDialog";

const Categories = props => {
    // eslint-disable-next-line react/prop-types
    const { itemOptions } = props;
    const { api, comp, pzstReg } = itemOptions;
    const { t } = i18n;
    const location = useLocation();
    const navigate = useNavigate();

    const state = location.state;
    const [loading, setLoading] = useState(false);
    const [fetched, setFetched] = useState(false);
    const [entry, setEntry] = useState(null);
    const [uuid, setUuid] = useState("");
    const [avCategories, setAvCategories] = useState([]);
    const [regEntries, setRegEntries] = useState([]);

    const [notActive, setNotActive] = useState(false);
    const [notFound, setNotFound] = useState(false);
    const [message, setMessage] = useState("");
    const [code, setCode] = useState("");
    const [openError, setOpenError] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [categoriesClosed, setCategoriesClosed] = useState(false);
    const [rejectedDialogOpen, setRejectedDialogOpen] = useState(false);
    const {
        handleSubmit,
        control,
        watch,
        formState: { errors, isValid }
    } = useForm({
        defaultValues: {
            code: ""
        }
    });
    const fetchEntry = function(uuid) {
        axios
            .get(`${api.getEntryAnonymously}${uuid}`)
            .then(function(response) {
                // console.log(response.data);
                setEntry(response.data);
                if (response.data.fromPzst || response.data) {
                    setNotActive(!response.data.clubActive);
                } else {
                    setNotActive(false);
                }
            })
            .catch(function(error) {
                console.log(error);
            });
    };
    const fetchCategories = function(uuid, entries) {
        setUuid(uuid);
        setRegEntries(entries);

        axios
            .get(`${api.getAvailableCategoriesForEntryAnonymously}${uuid}`)
            .then(function(response) {
            //    console.log(response.data);
                response.data.forEach(c => {
                    if (c.registration.open === false) {
                        setCategoriesClosed(true);
                    }
                });
                setAvCategories(response.data);
                setLoading(false);
                setFetched(true);
            })
            .catch(function(error) {
                setLoading(false);

                console.log(error);
            });
        setLoading(false);
    };
    useEffect(() => {
        if (state === null) {
            navigate("/");
        } else {
            setLoading(true);
            setCode(state.code);
            if (state.uuid === undefined) {
                axios
                    .post(`${api.addNewEntryAnonymously}${comp.id}`, state)
                    .then(function(response) {
                        fetchEntry(response.data.uuid);
                        fetchCategories(response.data.uuid, response.data.entries);
                    })
                    .catch(function(error) {
                        setLoading(false);

                        console.log(error);
                    });
            } else {
                fetchEntry(state.uuid);
                fetchCategories(state.uuid, state.entries);
            }
        }
    }, [state]);
    const handleOpenError = () => {
        setOpenError(true);
    };

    const handleCloseError = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setOpenError(false);
    };
    const handleOpenSuccess = () => {
        setOpenSuccess(true);
    };

    const handleCloseSuccess = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setOpenSuccess(false);
    };
    const onSubmit = data => {
        if (isValid || Object.entries(errors).length === 0) {
            axios
                .put(`${api.checkCode}${comp.id}`, { code: data.code })
                .then(res => {
                   // console.log(res);
                    setMessage(res.data);
                    if (res.status === 200) {
                        handleOpenSuccess();
                        setCode(data.code);
                        window.code = data.code;
                    } else {
                        handleOpenError();
                    }
                })
                .catch(function(error) {
                    setMessage(error.response.data);

                    handleOpenError();
                    console.log(error);
                });
            // console.log('ok', data);
        } else {
            console.log(errors);
        }
    };
    const onError = (errors, e) => {
        console.log(errors);
    };
    // console.log(entry, avCategories);
    // Polish athletes are not entered through the WDSF form; point them at the PZST registration.
    const polishViaWdsf = !!entry && entry.fromWdsf === true && !entry.fromPzst && entry.country === "Poland";
    const pzstUrl = polishViaWdsf && pzstReg ? (code ? `${pzstReg}#/starters/${code}` : `${pzstReg}#/starters`) : null;
    const redirectToPzst = pzstUrl !== null && avCategories.length === 0;
    return (
        <>
            <hr />
            <h2 className="display-6 mt-2">{t("reg.categories")}</h2>
            <p>{t("reg.info.categories")}</p>

            <Container maxWidth="xs" className="mb-2">
                {fetched && <Starter entry={entry} t={t} />}
                {loading && (
                    <Stack spacing={1}>
                        <Skeleton variant="rectangular" height={60} />
                        <Skeleton variant="rectangular" height={60} />
                        <Skeleton variant="rectangular" height={60} />
                    </Stack>
                )}
            </Container>
            <Container maxWidth="xs" className="mb-2">
                {fetched && notActive && <Alert severity="error">{t("reg.pzst.not_active_club")}</Alert>}
                {fetched && !notActive && <BlocksWithCategories code={code} categories={avCategories} regEntries={regEntries} reserveEntries={entry ? entry.reserveEntries : undefined} t={t} uuid={uuid} api={api} pzstUrl={pzstUrl} />}
                {fetched && !notActive && !redirectToPzst && (
                    <Button
                        variant="text"
                        startIcon={<HelpOutlineIcon />}
                        onClick={() => setRejectedDialogOpen(true)}
                        sx={{ mt: 2 }}
                    >
                        {t("reg.status.why_not_visible")}
                    </Button>
                )}
                <RejectedCategoriesDialog
                    open={rejectedDialogOpen}
                    onClose={() => setRejectedDialogOpen(false)}
                    uuid={uuid}
                    api={api}
                    t={t}
                />
                {!fetched && <CircularProgress />}
                {fetched && (comp.status.registrationOpen === false || categoriesClosed === true) && code === "" && (
                    <Stack spacing={2}>
                        <Alert severity="error" variant="outlined">
                            <AlertTitle>{t("reg.status.comp.closed")}</AlertTitle>
                            {t("reg.info.code_required")}
                        </Alert>
                        <Stack direction={"row"} spacing={2}>
                            <FormControl variant="standard" fullWidth>
                                <InputLabel htmlFor="code-enter">{t("code.enter")}</InputLabel>
                                <Controller
                                    name="code"
                                    control={control}
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            required
                                            error={errors.code !== undefined}
                                            startAdornment={
                                                <InputAdornment position="start">
                                                    <KeyIcon />
                                                </InputAdornment>
                                            }
                                        />
                                        // <TextField
                                        //     {...field}
                                        //     label={`${t("first_name")}`}
                                        //     type="text"
                                        //     required
                                        //     error={errors.firstName !== undefined}
                                        //     helperText={errors.firstName !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
                                        // />
                                    )}
                                />
                            </FormControl>
                            <Button variant="contained" color="warning" disabled={watch("code") === ""} onClick={handleSubmit(onSubmit, onError)}>
                                {t("code.use")}
                            </Button>
                        </Stack>
                    </Stack>
                )}
            </Container>
        </>
    );
};

export default Categories;
